import { ClearIcon } from '@app/components/icons/clear';
import { SearchIcon } from '@app/components/icons/search';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { ChangeEvent, useCallback, useRef } from 'react';

export const SearchInput = ({
  value,
  onChange,
  onClear,
}: {
  value: string;
  onChange: (evt: ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
}) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClear = useCallback(() => {
    if (!inputRef.current) return;
    inputRef.current.value = '';
    onClear();
  }, [onClear]);

  return (
    <div className="relative w-72">
      <SearchIcon className="absolute left-2 top-[.5625rem]" />
      <input
        type="text"
        ref={inputRef}
        value={value}
        placeholder={t('content-hub.search-page')}
        onChange={onChange}
        className="inline-block px-9 h-9 w-full border-neutral-b4 rounded-lg focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
      />
      {value && (
        <button
          className="absolute right-2 top-[.5625rem] hover:text-gray-600"
          onClick={handleClear}
          title={t('content-hub.clear-search')}
        >
          <ClearIcon />
        </button>
      )}
    </div>
  );
};
